import { render, staticRenderFns } from "./Nuevo-movimiento-de-stock.vue?vue&type=template&id=4830729f"
import script from "./Nuevo-movimiento-de-stock.vue?vue&type=script&lang=js"
export * from "./Nuevo-movimiento-de-stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports